export default __webpack_public_path__ + "static/media/Rectangle1.5bef256c.jpg";